import { Store } from 'pullstate'

import getVersionsStoreInit from '../StoresFunctions/getVersionsStoreInit'

const init = getVersionsStoreInit();

const VersionsStore = new Store(init);

export default VersionsStore;